import type { LinkProps } from 'react-router';

import { Link } from 'react-router';

import { clsx } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { getSharedButtonClassNames, type SharedButtonProps } from './Button.utils';

type Props = LinkProps & SharedButtonProps;

export const LinkButton = (props: Props) => {
  const { children, emphasis, icon, iconPlacement, ...delegated } = props;

  return (
    <Link {...delegated} className={clsx(getSharedButtonClassNames({ children, emphasis, icon, iconPlacement }), delegated.className)}>
      {icon && <Icon name={icon} size={22} />}
      {children}
    </Link>
  );
};
